import Api from './Api';

import * as Utils from '../utils/global';

export const sendFacebookInformation = () => {
  const fbp = Utils.getFbp();
  const fbc = Utils.getFbc();
  const body: {
    fbp?: string,
    fbc?: string,
  } = {};

  if (fbp) {
    body.fbp = fbp
  }
  if (fbc) {
    body.fbc = fbc
  }

  Api.post('/lots/start-publish', body);
}
